function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#093b98"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#192089"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  "data-name": "Group 3"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#63cccf",
  d: "M62.758 23.949A36.027 36.027 0 0177.476 5.531l-.465-.589C72.989-.328 66.595.277 60.071.156L51.66 0l9.8 43.234a36.158 36.158 0 011.3-19.285z",
  "data-name": "Path 1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M400.86 87.906a35.989 35.989 0 00-16.019 37.7l.3 1.324q.422 1.7 1 3.342a35.94 35.94 0 0033.742 23.952h46.932c-11.306-1.118-19.293-7.41-25.991-15.713l-6.482-8.21q-.7-.027-1.408-.027h-12.911a11.978 11.978 0 01-4.06-23.247z",
  "data-name": "Path 2",
  transform: "translate(-323.384 -82.375)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#63cccf",
  d: "M92.579 24.655a11.978 11.978 0 004.06 23.247h12.912q.707 0 1.408.027z",
  "data-name": "Path 3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#63cccf",
  d: "M143.432 71.852a35.944 35.944 0 00-32.473-23.927l6.482 8.21c6.698 8.307 14.685 14.599 25.991 15.717z",
  "data-name": "Path 4"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#0a1043",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.862 83.665C11.254 83.665 0 94.359 0 108.338c0 14.12 11.114 24.954 25.512 24.954a27.907 27.907 0 0019.292-8.388l-5.522-6.151a19.587 19.587 0 01-13.28 5.732 16.252 16.252 0 110-32.5 18.372 18.372 0 0113.28 6.36l5.452-6.85a27.193 27.193 0 00-18.872-7.83z",
  "data-name": "Path 5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.051 79.401a5.39 5.39 0 105.1 5.382 5.033 5.033 0 00-5.1-5.382zm4.544 16.076h-9.087v37.395h9.087z",
  "data-name": "Path 6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.171 102.677v-7.2h-9.087v37.395h9.087v-18.033c0-6.78 4.823-11.393 12.721-10.9v-8.814c-5.801.073-10.205 2.659-12.721 7.552z",
  "data-name": "Path 7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.339 102.677v-7.2h-9.086v37.395h9.086v-18.033c0-6.78 4.823-11.393 12.721-10.9v-8.814c-5.801.073-10.205 2.659-12.721 7.552z",
  "data-name": "Path 8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.064 95.477v18.448c0 6.011-3.495 10.625-9.366 10.694-5.033 0-8.039-3.145-8.039-8.387v-20.76h-9.156v23.416c0 8.807 5.173 14.329 13.56 14.329 5.941 0 10.415-2.307 13-7.269v6.919h9.153v-37.39z",
  "data-name": "Path 9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.903 95.058c-7.549 0-14.12 3.565-14.12 11.253-.07 13.281 19.432 9.507 19.432 16.426 0 2.447-2.377 3.495-5.522 3.495a20.875 20.875 0 01-12.652-4.613l-3.145 6.361c3.914 3.425 9.786 5.242 15.447 5.242 7.968 0 14.748-3.705 14.748-11.324 0-13.42-19.78-10.134-19.78-16.425 0-2.307 2.1-3.285 5.032-3.285a22.926 22.926 0 0110.974 3.425l3.285-6.571a25.2 25.2 0 00-13.699-3.984z",
  "data-name": "Path 10"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 195.091 133.292",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.aeae7fb9.svg";
export { ForwardRef as ReactComponent };